module.exports = __webpack_public_path__ + "images/花筑pr长图_07.jpg?v=e2e4139c";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu1/花筑pr长图_07.jpg
 ** module id = 26
 ** module chunks = 1 2
 **/